import React from "react";
import { ShieldCheck, Mail, Calendar } from "lucide-react";

export default function Compliance() {
  const LAST_UPDATED = "January 15, 2026";
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="compliance-page">
      <div className="flex items-center gap-3 mb-3">
        <span className="w-10 h-10 rounded-xl bg-[#E50914]/15 border border-[#E50914]/40 flex items-center justify-center">
          <ShieldCheck className="w-5 h-5 text-[#E50914]" />
        </span>
        <span className="text-[10px] uppercase tracking-[0.3em] text-[#E50914] font-bold">Legal</span>
      </div>
      <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight mb-3">
        18 U.S.C. § 2257 Compliance Statement
      </h1>
      <div className="flex items-center gap-2 text-xs text-zinc-500 mb-10">
        <Calendar className="w-3 h-3" /> Last updated: {LAST_UPDATED}
      </div>

      <div className="glass rounded-2xl p-6 sm:p-8 space-y-6 text-zinc-300 leading-relaxed">
        <Section title="Statement of Compliance">
          <p>
            All models, actors, actresses, performers, and other persons that appear in any visual
            depiction of actual or simulated sexually explicit conduct appearing on or otherwise
            contained in this website (<strong className="text-white">savageboy.net</strong>, the
            "Website") were <strong className="text-white">over the age of eighteen (18) years</strong>{" "}
            at the time such visual depictions were created.
          </p>
        </Section>

        <Section title="Nature of the Content">
          <p>
            The Website acts primarily as a curator and community platform. It does not itself
            produce, film, photograph, or otherwise create visual depictions of actual or simulated
            sexually explicit conduct. Content displayed or linked from the Website is either (a)
            embedded from third-party platforms that maintain their own § 2257 records, or (b)
            hosted on the operator's own Patreon page.
          </p>
          <p>
            To the extent any content published, embedded, or linked from the Website constitutes
            visual depictions of actual sexually explicit conduct as defined by 18 U.S.C. § 2256,
            the operator relies on the exemption set forth in 28 C.F.R. § 75.7 and/or on the
            § 2257 record-keeping performed by the original producers of such content.
          </p>
        </Section>

        <Section title="Records Custodian">
          <p>
            Records required to be maintained pursuant to 18 U.S.C. § 2257 and 28 C.F.R. § 75 for
            content that the operator has personally produced are kept by the following custodian
            of records:
          </p>
          <div className="rounded-xl bg-white/5 border border-white/10 p-4 text-sm">
            <div><span className="text-zinc-500">Custodian of Records:</span> SavageBoy</div>
            <div><span className="text-zinc-500">Contact email:</span>{" "}
              <a href="mailto:savageboyuncensored@gmail.com" className="text-[#E50914] hover:underline">
                savageboyuncensored@gmail.com
              </a>
            </div>
          </div>
          <p className="text-sm text-zinc-400">
            Please send written correspondence relating to § 2257 to the contact address above.
          </p>
        </Section>

        <Section title="Third-Party Content">
          <p>
            Content embedded from third-party platforms (including but not limited to YouTube,
            Patreon, and adult-content hosting providers) is displayed through iframes that link to
            their original source. The § 2257 statements of those third parties apply to such
            content and can be reviewed on their respective websites.
          </p>
        </Section>

        <Section title="User-Generated Content">
          <p>
            The Website does not permit users to upload sexually explicit visual depictions.
            Registered users may only interact through likes and text comments. Any comment
            violating this policy will be removed and the offending account may be suspended.
          </p>
        </Section>

        <Section title="Exemption Statement">
          <p>
            The owner and operator of the Website is not the primary or secondary producer of any
            of the sexually explicit content depicted on or linked from the Website within the
            meaning of 18 U.S.C. § 2257. All content embedded is provided by third parties who
            are neither owned nor controlled by the Website operator and to which the Website
            operator has no legal authority to make representations regarding compliance.
          </p>
        </Section>

        <Section title="Age Verification">
          <p>
            By accessing or using the Website you affirm that you are at least eighteen (18) years
            of age (or the age of majority in your jurisdiction, whichever is higher) and that you
            consent to viewing sexually oriented material.
          </p>
        </Section>

        <div className="border-t border-white/10 pt-4 text-xs text-zinc-500">
          Questions? Contact{" "}
          <a href="mailto:savageboyuncensored@gmail.com" className="text-[#E50914] hover:underline inline-flex items-center gap-1">
            <Mail className="w-3 h-3" /> savageboyuncensored@gmail.com
          </a>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-display font-bold text-xl text-white mb-3">{title}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
